import React, { useState } from "react";
import "./NestedPipeSelector.scss";

const NestedPipeSelector = ({ pipes, selectedGateIds, onChange }) => {
  const [expandedPipes, setExpandedPipes] = useState({});

  const togglePipeExpand = (pipeId) => {
    setExpandedPipes((prev) => ({
      ...prev,
      [pipeId]: !prev[pipeId],
    }));
  };

  const handlePipeSelect = (pipe) => {
    const pipeGateIds = pipe.gates.map((g) => g.id);
    const isAllSelected = pipeGateIds.every((id) =>
      selectedGateIds.includes(id)
    );

    if (isAllSelected) {
      // unselect all gates in pipe
      onChange(selectedGateIds.filter((id) => !pipeGateIds.includes(id)));
    } else {
      // add all pipe gates
      onChange([...new Set([...selectedGateIds, ...pipeGateIds])]);
    }
  };

  const handleGateSelect = (gateId) => {
    if (selectedGateIds.includes(gateId)) {
      onChange(selectedGateIds.filter((id) => id !== gateId));
    } else {
      onChange([...selectedGateIds, gateId]);
    }
  };

  const isPipeFullySelected = (pipe) =>
    pipe.gates.every((g) => selectedGateIds.includes(g.id));

  return (
    <div className="nested-dropdown">
      {pipes.map((pipe) => (
        <div key={pipe.id} className="pipe-item">
          <div className="pipe-header">
            <label>
              <input
                type="checkbox"
                checked={isPipeFullySelected(pipe)}
                onChange={() => handlePipeSelect(pipe)}
              />
              {`Pipe ${pipe.local_id}`}
            </label>
            <button
              className="expand-btn"
              onClick={() => togglePipeExpand(pipe.id)}
            >
              {expandedPipes[pipe.id] ? "▼" : "▶"}
            </button>
          </div>

          {expandedPipes[pipe.id] && (
            <div className="gate-list">
              {pipe.gates.map((gate) => (
                <label key={gate.id} className="gate-item">
                  <input
                    type="checkbox"
                    checked={selectedGateIds.includes(gate.id)}
                    onChange={() => handleGateSelect(gate.id)}
                  />
                  {`Gate ${gate.local_id}`}
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default NestedPipeSelector;

